import { DateTime } from 'luxon'

// Generic type for date fields
interface DateFields {
	createdAt?: string
	updatedAt?: string
	deletedAt?: string | null | undefined
}

// Generic mapper class with common transformations
export class GenericMapper {
	// Date transformations
	public static mapDates<T extends DateFields>(
		dto: T
	): {
		createdAt?: DateTime
		updatedAt?: DateTime
		deletedAt?: DateTime
	} {
		return {
			createdAt: dto.createdAt ? DateTime.fromISO(dto.createdAt) : undefined,
			updatedAt: dto.updatedAt ? DateTime.fromISO(dto.updatedAt) : undefined,
			deletedAt: dto.deletedAt ? DateTime.fromISO(dto.deletedAt) : undefined,
		}
	}

	// Number transformations
	public static mapNumber(
		value: number | string | null | undefined
	): number | null {
		if (value === null || value === undefined) return null
		const num = Number(value)
		return isNaN(num) ? null : num
	}
}
